import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
/*
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);*/

if (process.env.NODE_ENV === 'production') {
  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js?render=6LcxUv4qAAAAADhsTo-43OEhlVqmcfE1h2Wu26An';
  script.defer = true;
  document.head.appendChild(script);
}

root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
